import { push } from "connected-react-router";
import React from "react";
import { useDispatch } from "react-redux";
import { ROUTE_PATH } from "../../../app/constants";
import { Button, Header, Paragraph } from "../../../components/RegularComponents";
import { setMortgageProperty } from "../../../redux/slice/primaryAgencyApplicationSlice";

const MORTGAGE_APPLICATION_PROPERTY = "mlHasRoleRjsc";
// const applicationType = APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE;
// const applicationMode = APPLICATION_MODE_NEW;

export const HasRoleRjsc = (props) => {
  const dispatch = useDispatch();

  //const [applicationSaveError, setApplicationSaveError] = useState(false);

  const handleNext = (complianceOfficer) => () => {
    dispatch(
      setMortgageProperty({
        key: MORTGAGE_APPLICATION_PROPERTY,
        value: complianceOfficer,
      })
    );

    // dispatch(saveBusinessLicenceApplicationData(
    //   applicationType, applicationMode))
    //   .then(data => {
    //     const nextPath = complianceOfficer
    //         ? ROUTE_PATH.ML_IS_RESIDENT_CANADA
    //         : ROUTE_PATH.ML_CHOOSE_NEW_COMPLIANCE_OFFICER;
    //       dispatch(push(`${ROUTE_PATH.ML_APP}${nextPath}`));
    //   })
    //   .catch(err => {
    //     //setApplicationSaveError(true)
    //   })

    const nextPath = complianceOfficer
      ? ROUTE_PATH.MA_SELECT_COMPANY_TYPE
      : ROUTE_PATH.MA_CHOOSE_NEW_COMPLIANCE_OFFICER;
    dispatch(push(`${ROUTE_PATH.MA_APP}${nextPath}`));
  
  };

  return (
    <div className="container">
      {/* Title */}

      <div className="row">
        <div className="col-lg-8">
          <Header
            id="rjsc-detail-review-header"
            header={"Your role at your company"}
          />
          <Paragraph
            id="rjsc-detail-review-text"
            text={[
              "As the compliance officer for your company, you must have one of the following roles at your company: director, partner, officer, or sole proprietor.",
              'Most companies in Nova Scotia are listed in the Registry of Joint Stock Companies. If you aren\'t sure of your role, you can find your company profile in the <a style="text-decoration: underline" href="https://rjsc.novascotia.ca/" target="_blank">Registry of Joint Stock Companies</a>',
              "Are you a director, partner, officer, or sole proprietor?"   
            ]}
          />
        </div>
      </div>

      {/* Yes/No Answer */}
      <div className="row">
        <div className="col-lg-2">
          <Button
            className="ns-btn-yes-no"
            buttonType="regular_primary"
            onClick={handleNext(true)}
            text="Yes"
          />
        </div>

        <div className="col-lg-2">
            <Button
              className="ns-btn-yes-no"
              buttonType="regular_primary"
              onClick={handleNext(false)}
              value={false}
              text="No"
            />
          </div>
      </div>
    </div>
  );
};
